import React from 'react';
import Button from '../../../../Components/Button/Button';
// @ts-ignore
import styles from './DENTModalOverviewActionButtons.module.scss';

interface Props {
	onSubmit: () => void;
}

const DENTModalOverviewActionButtons = ({ onSubmit }: Props) => {
	return (
		<div className={styles.container}>
			<Button title={'base.shared.form.send'} onClick={onSubmit} />
		</div>
	);
};

export default DENTModalOverviewActionButtons;
